import { useState, useEffect } from 'react';
import { promptAPI } from '../services/api';
import { Prompt } from '../types';
import toast from 'react-hot-toast';

export const usePrompt = (id: number | null) => {
  const [prompt, setPrompt] = useState<Prompt | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchPrompt = async (promptId: number) => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await promptAPI.getPromptById(promptId);
      setPrompt(response);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : '프롬프트를 불러오는데 실패했습니다.';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const logUsage = async (feedback?: number, comment?: string) => {
    if (!prompt) return;
    
    try {
      await promptAPI.logUsage(prompt.id, {
        feedback,
        feedback_comment: comment,
      });
      
      // Update usage count locally
      setPrompt(prev => prev ? { ...prev, usage_count: (prev.usage_count || 0) + 1 } : null);
      
      toast.success('사용 기록이 저장되었습니다.');
    } catch (err) {
      console.error('Failed to log usage:', err);
    }
  };

  const copyToClipboard = async (content: string) => {
    try {
      await navigator.clipboard.writeText(content);
      toast.success('클립보드에 복사되었습니다!');
      
      // Log usage when copying
      logUsage();
    } catch (err) {
      toast.error('복사에 실패했습니다.');
    }
  };

  useEffect(() => {
    if (id) {
      fetchPrompt(id);
    } else {
      setPrompt(null);
    }
  }, [id]);

  return {
    prompt,
    loading,
    error,
    refetch: () => id && fetchPrompt(id),
    logUsage,
    copyToClipboard,
  };
};